import { render, staticRenderFns } from "./scoreDetail.vue?vue&type=template&id=62dcb11e&scoped=true&"
import script from "./scoreDetail.vue?vue&type=script&lang=js&"
export * from "./scoreDetail.vue?vue&type=script&lang=js&"
import style0 from "./scoreDetail.vue?vue&type=style&index=0&id=62dcb11e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62dcb11e",
  null
  
)

export default component.exports